
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 80 80"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#F2994A","d":"M67.68 10H12.32A4.32 4.32 0 008 14.33v37.03a4.32 4.32 0 004.32 4.34h55.36A4.32 4.32 0 0072 51.36V14.33A4.3 4.3 0 0067.68 10z"}}),_c('path',{attrs:{"fill":"#FFCEA0","d":"M57.67 61.98H22.3a4.02 4.02 0 000 8.02h35.38a4.02 4.02 0 000-8.02z"}}),_c('path',{attrs:{"fill":"#DE8E44","d":"M36.03 55.7V62h7.95v-6.3h-7.95z"}}),_c('path',{attrs:{"fill":"#FFCEA0","d":"M51.5 35.67c-6.55 0-11.93 4.83-12.46 10.98-.04.55.4 1 .96 1h23c.55 0 1-.45.96-1-.53-6.15-5.9-10.98-12.46-10.98z"}}),_c('circle',{attrs:{"cx":"51.5","cy":"26.29","r":"7.29","fill":"#FFCEA0"}}),_c('path',{attrs:{"fill":"#FFCEA0","fill-rule":"evenodd","d":"M16 26.9a1.94 1.94 0 013.01-1.58l5.95 3.88v-.01l5.73 3.72a1.86 1.86 0 010 3.15l-11.68 7.6c-1.28.84-3.01-.06-3.01-1.58V26.91z","clip-rule":"evenodd"}})])
          )
        }
      }
    